const isDev = import.meta.env.DEV;

export function devLog(...args: unknown[]) {
	if (isDev) console.log(...args);
}

export function devError(...args: unknown[]) {
	if (isDev) console.error(...args);
}
